module.exports = __webpack_public_path__ + "img/pay_step1_left_hover.69d45cbe.png";